import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {
    CREATE_PROJECT_STAGE_PHASE_TEMPLATE, CREATE_PROJECT_STAGE_PHASE_TEMPLATE_ERROR, CREATE_PROJECT_STAGE_PHASE_TEMPLATE_SUCCESS,
    DELETE_PROJECT_STAGE_PHASE_TEMPLATE, DELETE_PROJECT_STAGE_PHASE_TEMPLATE_ERROR, DELETE_PROJECT_STAGE_PHASE_TEMPLATE_SUCCESS,
    FETCH_PROJECT_STAGE_PHASE_TEMPLATES, FETCH_PROJECT_STAGE_PHASE_TEMPLATES_ERROR, FETCH_PROJECT_STAGE_PHASE_TEMPLATES_SUCCESS,
    FETCH_PROJECT_STAGE_PHASE_TEMPLATE_BY_ID, FETCH_PROJECT_STAGE_PHASE_TEMPLATE_BY_ID_ERROR, FETCH_PROJECT_STAGE_PHASE_TEMPLATE_BY_ID_SUCCESS,
    ProjectStagePhaseTemplateActionTypes,
    RESTORE_PROJECT_STAGE_PHASE_TEMPLATE, RESTORE_PROJECT_STAGE_PHASE_TEMPLATE_ERROR, RESTORE_PROJECT_STAGE_PHASE_TEMPLATE_SUCCESS,
    UPDATE_PROJECT_STAGE_PHASE_TEMPLATE, UPDATE_PROJECT_STAGE_PHASE_TEMPLATE_ERROR, UPDATE_PROJECT_STAGE_PHASE_TEMPLATE_SUCCESS
} from "../../actions/projects/ProjectStagePhaseTemplateActions";
import {ProjectStagePhaseTemplate} from "../../models/projects/ProjectStagePhaseTemplate";
import {BasicReducerState, initialReducerState} from "../BasicReducerState";

export interface ProjectStagePhaseTemplateState
    extends BasicReducerState< Nullable< ProjectStagePhaseTemplate[] >, Nullable< ProjectStagePhaseTemplate > > {

}


const initialState: ProjectStagePhaseTemplateState = initialReducerState();

/**
 * PHASE TEMPLATE REDUCER
 *
 * @see ProjectStagePhaseTemplateActionTypes
 * @see ProjectStagePhaseTemplateModule
 */
export function ProjectStagePhaseTemplateReducer(
    state: ProjectStagePhaseTemplateState = initialState,
    action: ProjectStagePhaseTemplateActionTypes
) {

    switch( action.type ) {
        case FETCH_PROJECT_STAGE_PHASE_TEMPLATES:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: startFetchingRequestState()
                },
            };
        case FETCH_PROJECT_STAGE_PHASE_TEMPLATES_SUCCESS:
            return {
                ...state,
                totalEntries: action.payload.totalEntries,
                entries: {
                    current: action.payload.entries,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_PROJECT_STAGE_PHASE_TEMPLATES_ERROR:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: errorFetchingRequestState( action.error )
                }
            };
        case FETCH_PROJECT_STAGE_PHASE_TEMPLATE_BY_ID:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.phaseTemplateId.rawValue ]: {
                        entry: null,
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_PROJECT_STAGE_PHASE_TEMPLATE_BY_ID_SUCCESS:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.phaseTemplate.phaseTemplateId.rawValue ]: {
                        entry: action.phaseTemplate,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_PROJECT_STAGE_PHASE_TEMPLATE_BY_ID_ERROR:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.phaseTemplateId.rawValue ]: {
                        ...( state.detailedEntries[ action.phaseTemplateId.rawValue ] ?? { entry: null } ),
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        case CREATE_PROJECT_STAGE_PHASE_TEMPLATE:
        case UPDATE_PROJECT_STAGE_PHASE_TEMPLATE:
        case DELETE_PROJECT_STAGE_PHASE_TEMPLATE:
        case RESTORE_PROJECT_STAGE_PHASE_TEMPLATE:
            return {
                ...state,
                changingRequest: startFetchingRequestState()
            };
        case CREATE_PROJECT_STAGE_PHASE_TEMPLATE_SUCCESS:
        case UPDATE_PROJECT_STAGE_PHASE_TEMPLATE_SUCCESS:
        case DELETE_PROJECT_STAGE_PHASE_TEMPLATE_SUCCESS:
        case RESTORE_PROJECT_STAGE_PHASE_TEMPLATE_SUCCESS:
            return {
                ...state,
                changingRequest: successFetchingRequestState()
            };
        case CREATE_PROJECT_STAGE_PHASE_TEMPLATE_ERROR:
        case UPDATE_PROJECT_STAGE_PHASE_TEMPLATE_ERROR:
        case DELETE_PROJECT_STAGE_PHASE_TEMPLATE_ERROR:
        case RESTORE_PROJECT_STAGE_PHASE_TEMPLATE_ERROR:
            return {
                ...state,
                changingRequest: errorFetchingRequestState( action.error )
            };
        default:
            return state;
    }

}
